import axios from "axios";

const backendValidUser = axios.create({
  // baseURL: "https://be.sadaatpoultryservices.com/api",
  baseURL: "http://localhost:7000/api",

});

// Add a request interceptor
backendValidUser.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("myToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export default backendValidUser;
